import WalletData from '../components/wallet/WalletData';
import WalletPage from '../components/wallet/WalletTable';

export interface IWalletTransaction {
  id: string;
  transactionId: string;
  tokenAmount: string;
  numberOfToken: string;
  tokenType: 'MINT' | 'BURN' | 'TRANSFER';
  type: 'CREDITED' | 'DEBITED';
  wallet: 'CASH';
  remarks: string;
  status: 'SUCCESS' | 'FAILED' | 'PENDING';
  transactionDate: string;
  createdAt: string;
  updatedAt: string;
}

const Wallet = () => {
  return (
    <>
      <WalletData />
      <WalletPage />
    </>
  );
};

export default Wallet;
